import { useTheme } from '../../hooks/useTheme';
import type { Currency } from '../../hooks/useCurrency';

interface CurrencyToggleProps {
  currency: Currency;
  onChange: (next: Currency) => void;
  /** Etiqueta accesible del grupo. */
  ariaLabel?: string;
}

const OPTIONS: { id: Currency; label: string; aria: string }[] = [
  { id: 'USD', label: 'US$', aria: 'Ver precios en dólares estadounidenses' },
  { id: 'DOP', label: 'RD$', aria: 'Ver precios en pesos dominicanos' },
];

/**
 * Selector de moneda compartido por los planes generales y los de dealers.
 * Los precios son valores comerciales fijos por moneda: no hay conversión
 * automática por tasa del día.
 */
export default function CurrencyToggle({
  currency,
  onChange,
  ariaLabel = 'Seleccionar moneda de los precios',
}: CurrencyToggleProps) {
  const { theme } = useTheme();
  const isLight = theme === 'light';

  return (
    <div
      className="inline-flex items-center gap-1 rounded-full px-1 py-1 border"
      role="group"
      aria-label={ariaLabel}
      style={{
        backgroundColor: isLight ? '#e8eef8' : 'rgba(12,22,48,0.8)',
        borderColor: isLight ? '#c5d4e8' : 'rgba(255,255,255,0.10)',
      }}
    >
      {OPTIONS.map((o) => {
        const active = currency === o.id;
        return (
          <button
            key={o.id}
            type="button"
            onClick={() => onChange(o.id)}
            aria-pressed={active}
            aria-label={o.aria}
            className={`px-4 py-1.5 rounded-full text-xs font-bold font-body transition-all duration-200 cursor-pointer whitespace-nowrap touch-manipulation ${active ? 'bg-electric text-navy-950' : ''}`}
            style={{
              color: active
                ? undefined
                : isLight
                  ? 'rgba(10,22,40,0.55)'
                  : 'rgba(255,255,255,0.60)',
            }}
          >
            {o.label}
          </button>
        );
      })}
    </div>
  );
}
